import type { TFunction } from 'i18next';

export const localSpecialtyRowLabel = (t: TFunction) => (idx: number) =>
	idx === 0
		? t('Primary Local Specialty')
		: t('Local Specialty {{n}}', { n: idx + 1 });
